import { AnyAccountInvitationEntity } from '../../../domain/accounts';
import { AccountInvitationDto } from '../../../api';
import { AccountInvitationAdapter } from '../../../app/accounts';
import { AccountInvitationImplConfig } from './invitationImplConfig';

export function createAccountInvitationImpl(
    config: AccountInvitationImplConfig
): AccountInvitationAdapter {
    const {
        api: { platform: api },
    } = config;

    function toEntity(dto: AccountInvitationDto): AnyAccountInvitationEntity {
        return {
            kind: dto.data.kind,
            id: dto.id,
            status: dto.data.status,
            createdAt: dto.created_at,
            updatedAt: dto.updated_at ?? dto.created_at,
        };
    }

    return {
        async find(context, query) {
            const response = await api.invitation.list(context, {
                source: query.source,
            });
            return {
                total: response.data.length,
                limit: query.limit ?? 10,
                items: response.data.map(toEntity),
            };
        },
        async create(context, props) {
            const response = await api.invitation.create(context, {
                data: {
                    kind: props.kind,
                    text: props.text,
                    source:
                        props.source.kind === 'group'
                            ? {
                                  kind: 'group',
                                  group_ids: [props.source.id],
                              }
                            : undefined,
                },
            });
            return toEntity(response);
        },
    };
}
